/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Product/PrevNext',[
    'jquery',
    'lodash',
    'global/all'
], function ($, _, Roc) {
    // Object to handle NextProduct/PreviousProduct/Back to results Urls on productNextPrev widget. It uses localStorage.
    //
    // When user goes from search results to product details the data as follows is stored in localStorage (it's implemented on HawkSearch side)
    // key: 'trackingId'; value: corresponding guid; - this is tracking id of current search page with all filters included 
    // key: value of element 'trackingId'; value: the stringify object:
    // {
    //      query - value of current search - all filters included
    //      items - list of objects for every returned product on page, where {id} is equal to element index (starts from 1) and {url} is equal to product url 
    //      data - object where {nofResults} - number of search results, {index} - index of chosen element, {mpp} - max items per page, {pg} - current page
    // }

    var pub = {};

    // private fields
    var rocData; // roc platform url, ip address, user id. These are data retrived from server.
    var trackingIdValue; // value used to indicate proper search data stored in localStorage.
    var searchResults; // parsed data stored in localStorage once user went from search results to product details.
    var $htmlElements =
    {
        backToLinkElement: $('div.backToLink'),
        backToHomeLinkElement: $('div.backToHomeLink'),
        pageControlElement: $('div.pageControl')
    }; // HTML elements from widget in which data will be rendered.

    // private methods

    // indicate if we have required data to render proper back to results URL and if currenlty displayed product exist in stored items 
    function shouldBackToLinkBeVisible(isProductpage) {
        if (!searchResults || !searchResults.query || !searchResults.items) {
            return false;
        }

        if (isProductpage) {
            var currentStoredItem = _.find(searchResults.items,
                function (obj) {
                    return obj.url === location.pathname;
                });

            if (!currentStoredItem) {
                return false;
            }
        }

        return true;
    };

    // indicate if we have required data to render next/prev products urls and if our current stored product is equal to currently displayed one.
    function shouldPageControlBeVisible() {
        if (!searchResults || !searchResults.query || !searchResults.data || !searchResults.items) {
            return false;
        }

        var index = parseInt(searchResults.data.index);
        var currentPage = parseInt(searchResults.data.pg);
        var itemsPerPage = parseInt(searchResults.data.mpp);

        var currentItemIndex = index + ((currentPage - 1) * itemsPerPage);
        var currentStoredItem = _.find(searchResults.items, function (obj) { return obj.id === currentItemIndex });
        if (!currentStoredItem || currentStoredItem.url !== location.pathname) {
            return false;
        }

        return true;
    };

    // get search and hash data from whole url stored in query.
    function parseOriginalSearch() {
        var originalSearch = searchResults.query;

        if (originalSearch.indexOf('?') >= 0) {
            originalSearch = originalSearch.substring(originalSearch.indexOf('?') + 1);
        } else if (originalSearch.indexOf('#') >= 0) {
            originalSearch = originalSearch.substring(originalSearch.indexOf('#') + 1);
        }

        if (originalSearch.slice(-1) === '/') {
            originalSearch = originalSearch.substring(0, originalSearch.length - 1);
        }

        return originalSearch;
    }

    // hide back to results HTML element
    function hideBackToLink() {
        $htmlElements.backToLinkElement.hide();
    };

    function hideBackToHomeLink() {
        $htmlElements.backToHomeLinkElement.hide();
    };
    // hide page control (element that contains next/prev urls) HTML
    function hidePageControl() {
        $htmlElements.pageControlElement.hide();
    };

    // update Back to results with proper href and show
    function setBackToLinkHref() {
        $htmlElements.backToLinkElement.find('a').attr('href', searchResults.query);
        $htmlElements.backToLinkElement.show();
    };

    function setBackToHomeLinkUrl() {
        $htmlElements.backToHomeLinkElement.find('a').attr('href', window.location.origin);
        $htmlElements.backToHomeLinkElement.show();
    };
    // update currect value of tracking id element in localStorage
    function updateTrackingId() {
        localStorage.setItem('trackingId', trackingIdValue);
    };

    // update stored data in localStorage (whole object)
    function updateStoredData(results) {
        updateTrackingId();
        localStorage.setItem(trackingIdValue, JSON.stringify(results));
    };

    // handle negative callback from Roc when calling GetSearchResults
    function negativeSearchResultsCallback(failResponse) {
        hidePageControl();
        Roc.Logger.error('Failed to get search results');
    };

    // retunr relatve url of absolute one stored as string
    function getRelativeUrl(absoluteUrl) {
        var a = document.createElement('a');
        a.href = absoluteUrl;
        var relativeUrl = a.pathname.indexOf('/') === 0 ? a.pathname : '/' + a.pathname;
        return relativeUrl;
    };

    // add new items to collection and update object in localStorage
    function pushNewItemsToCollection(currPage, newItems) {
        var newProductItemsLength = newItems.length;
        for (var it = 0; it < newProductItemsLength; it++) {
            searchResults.items.push({
                id: it + 1 + ((currPage - 1) * parseInt(searchResults.data.mpp)),
                url: getRelativeUrl(newItems[it].customUrl)
            });
        }
        updateStoredData(searchResults);
    }

    // add new items to collection (on left side) and update object in localStorage
    function unShiftNewItemsToCollection(currPage, newItems) {
        var newProductItemsLength = newItems.length;
        for (var it = newProductItemsLength - 1; it >= 0; it--) {
            searchResults.items.unshift({
                id: it + 1 + ((currPage - 1) * parseInt(searchResults.data.mpp)),
                url: getRelativeUrl(newItems[it].customUrl)
            });
        }
        updateStoredData(searchResults);
    }

    // handle positive callBack from Roc after calling GetSearchResults
    // update collection of itmes in localStorage
    // redirect to next or prev element - depends on which event was triggered
    function positiveSearchResultsCallback(resObject, index, currentItemIndex, currPage, isNextPage) {
        if (!resObject || resObject.responseCode !== 1) {
            Roc.Logger.error('Failed to get search results');
        }

        if (resObject.entity) {
            searchResults.data.index = index;
            searchResults.data.pg = currPage;
            searchResults.data.nofResults = resObject.entity.nofResults;

            if (isNextPage) {
                pushNewItemsToCollection(currPage, resObject.entity.items);
                if (resObject.entity.items.length > 0) {
                    document.location.href = getRelativeUrl(resObject.entity.items[0].customUrl);
                } else {
                    $htmlElements.nextProductElement.hide();
                }
            } else {
                unShiftNewItemsToCollection(currPage, resObject.entity.items);
                if (resObject.entity.items.length > 0) {
                    document.location.href = getRelativeUrl(resObject.entity.items[resObject.entity.items.length - 1].customUrl);
                } else {
                    $htmlElements.nextProductElement.hide();
                }
            }
        } else {
            Roc.Logger.error('Failed to get search results. Probably HawkSearch returned wrong data.');
        }
    };

    // get parameter value from url hash by name.
    function getHashVariable(variable) {
        var vars = searchResults.query.substring(searchResults.query.indexOf('#') + 1).split('&');
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');
            if (pair[0].toLowerCase() === variable.toLowerCase()) {
                return pair[1];
            }
        }
        return null;
    };

    // get parameter value from url query by name.
    function getQueryStringVariable(variable) {
        var vars = searchResults.query.substring(searchResults.query.indexOf('?') + 1).split('&');
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');
            if (pair[0].toLowerCase() === variable.toLowerCase()) {
                return pair[1];
            }
        }
        return null;
    };

    // update parameter pg in query to new value or add if not exists
    function addOrUpdatePgParameterInQuery(currPage) {
        var query = parseOriginalSearch();
        if (!getHashVariable('pg') || !getQueryStringVariable('pg')) {
            if (query) {
                query += '&pg=' + currPage;
            } else {
                query = 'pg=' + currPage;
            }
        } else {
            query = query.replace('pg', 'oldpg');
            query += '&pg=' + currPage;
        }
        return query;
    }

    // calls Roc API (AJAX) to get SearchResults from HawkSearch
    // update localStorage object in positive case and redirect to next/prev product depends on triggered event
    function getSearchResults(index, currentItemIndex, currPage, isNextPageRequired) {
        var queryParam = '?query=' + encodeURIComponent(addOrUpdatePgParameterInQuery(currPage));
        var userIdParam = '&userId=' + rocData.userId;
        var userAgentParam = '&userAgent=' + encodeURIComponent(navigator.userAgent);
        var clientIpParam = '&clientIp=' + encodeURIComponent(rocData.clientIp);
        var url = rocData.rocUrl + '/api/rocsearch/searchresults' + queryParam + userIdParam + userAgentParam + clientIpParam;

        $.ajax({
            type: 'GET',
            url: url,
            contentType: 'application/json; charset=utf-8'
        }).done(function (successResponse) {
            positiveSearchResultsCallback(successResponse, index, currentItemIndex, currPage, isNextPageRequired);
        }).fail(function (failResponse) {
            negativeSearchResultsCallback(failResponse);
        });
    };

    // Sets previous product element
    // if previous product is available in items collection (from localStorage) update href with product url and update index in localStorage.
    // if is not retrieve more elements from HawkSearch via Roc API call and update object in localStorage as well.
    function setPreviousProductElement(currentItemIndex, currentPage, itemsPerPage, index) {
        if (currentItemIndex !== 1) {
            var previousProduct = _.find(searchResults.items, function (obj) { return obj.id === currentItemIndex - 1 });
            if (previousProduct) {
                $htmlElements.previousProductElement.attr('href', previousProduct.url);
                $htmlElements.previousProductElement.mousedown(function () {
                    searchResults.data.index = index;
                    updateStoredData(searchResults);
                    return true;
                });
            } else {
                $htmlElements.previousProductElement.mousedown(function () {
                    getSearchResults(itemsPerPage, currentItemIndex - 1, currentPage - 1, false);
                    return true;
                });
            }
            $htmlElements.previousProductElement.show();
        }
    }

    // Sets next product element
    // if next product is available in items collection (from localStorage) update href with product url and update index in localStorage.
    // if is not retrieve more elements from HawkSearch via Roc API call and update object in localStorage as well.
    function setNextProductElement(currentItemIndex, currentPage, index) {
        if (currentItemIndex < searchResults.data.nofResults) {
            var nextProduct = _.find(searchResults.items, function (obj) { return obj.id === currentItemIndex + 1 });
            if (nextProduct) {
                $htmlElements.nextProductElement.attr('href', nextProduct.url);
                $htmlElements.nextProductElement.mousedown(function () {
                    searchResults.data.index = index;
                    updateStoredData(searchResults);
                    return true;
                });
            } else {
                $htmlElements.nextProductElement.mousedown(function () {
                    getSearchResults(1, currentItemIndex + 1, currentPage + 1, true);
                    return true;
                });
            }
            $htmlElements.nextProductElement.show();
        }
    }

    // Sets number of elements value in HTML on widget.
    function setNumberOfElement(currentItemIndex) {
        if (searchResults.data.nofResults && ($htmlElements.nextProductElement.css('display') !== 'none' || $htmlElements.previousProductElement.css('display') !== 'none')) {
            $htmlElements.numberOfElement.text('(' + currentItemIndex + ' of ' + searchResults.data.nofResults + ')');
            $htmlElements.numberOfElement.show();
            $htmlElements.pageControlElement.show();
        }
    }

    // Sets page control HTML values on widget.
    function setPageControlValues() {
        var index = parseInt(searchResults.data.index);
        var currentPage = parseInt(searchResults.data.pg);
        var itemsPerPage = parseInt(searchResults.data.mpp);

        var currentItemIndex = index + ((currentPage - 1) * itemsPerPage);

        var firstStoredIndex = searchResults.items[0].id;
        var lastStoredIndex = searchResults.items[searchResults.items.length - 1].id;

        if (currentItemIndex >= firstStoredIndex && currentItemIndex <= lastStoredIndex) {
            setPreviousProductElement(currentItemIndex, currentPage, itemsPerPage, index - 1);
            setNextProductElement(currentItemIndex, currentPage, index + 1);
            setNumberOfElement(currentItemIndex);
        } else {
            Roc.Logger.error('Cannot set prev/next urls. Index out of range.');
        }
    };

    // public section

    // initialize method
    // checks if user has access to localStorage
    // initialize private elements, retrieve data from localStorage
    // indicates whether product details urls can be visible or not
    // handles propulating proper values for urls
    // register events on page refresh and on urls mouse down (if required)
    pub.InitializeProductDetailsUrls = function (platformUrl, userId, clientIp) {
        if (typeof (Storage) === 'undefined') {
            return;
        }

        trackingIdValue = window.localStorage.getItem('trackingId');
        searchResults = JSON.parse(window.localStorage.getItem(trackingIdValue));

        if (shouldBackToLinkBeVisible(true)) {
            setBackToLinkHref();
            hideBackToHomeLink();
        } else {
            hideBackToLink();
            setBackToHomeLinkUrl();
        }

        if (shouldPageControlBeVisible()) {
            rocData = {
                rocUrl: platformUrl,
                userId: userId,
                clientIp: clientIp
            };
            $htmlElements.previousProductElement = $htmlElements.pageControlElement.find('a.prev');
            $htmlElements.nextProductElement = $htmlElements.pageControlElement.find('a.next');
            $htmlElements.numberOfElement = $htmlElements.pageControlElement.find('span.number-of');
            setPageControlValues();
        } else {
            hidePageControl();
        }

        if (trackingIdValue) {
            // update tracking id when page is refreshed or left
            window.addEventListener('beforeunload', function (event) {
                updateTrackingId();
            });
        }
    };

    pub.InitializeBackToResultsLinks = function () {
        if (typeof (Storage) === 'undefined') {
            return;
        }

        trackingIdValue = window.localStorage.getItem('trackingId');
        searchResults = JSON.parse(window.localStorage.getItem(trackingIdValue));

        if (shouldBackToLinkBeVisible(false)) {
            setBackToLinkHref();
            hideBackToHomeLink();

        } else {
            hideBackToLink();
            setBackToHomeLinkUrl();
        }

        if (trackingIdValue) {
            // update tracking id when page is refreshed or left
            window.addEventListener('beforeunload', function (event) {
                updateTrackingId();
            });
        }
    };

    Roc.Logger.debug('PrevNext.js Loaded:', pub);

    return pub;
});

